module.exports = __webpack_public_path__ + "static/media/tv-show-bg1.6becb8b0.jpg";